<template>
  <div class="form_usuario">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout row wrap>
          <v-flex
            :class="[displayFlex, item.class]"
            v-for="(item,i) in formUsuario.form.items"
            :key="i"
            v-if="item.type == 'T' && !create ||
                create && item.item_id == 'nome' ||
                create && item.item_id == 'email'"
          >
            <v-text-field
              color="teal"
              v-model="item.valor"
              :prepend-icon="item.prepIcon"
              :mask="item.mask"
              validate-on-blur
              clearable
              :rules="item.item_id == 'nome' ? nomeRules : item.item_id == 'email' ? emailRules : undefined"
              :disabled="edit && item.item_id == 'email'"
            >
              <template slot="label">{{item.text}}:</template>
            </v-text-field>
          </v-flex>

          <v-flex
            :class="displayFlex"
            v-for="(item,i) in formUsuario.form.items"
            :key="i"
            v-if="item.type == 'D' && !create"
          >
            <v-menu
              :ref="item.index"
              :close-on-content-click="false"
              v-model="item.index"
              :nudge-right="40"
              color="teal"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                :close-on-content-click="true"
                color="teal"
                slot="activator"
                v-model="item.valor"
                persistent-hint
                prepend-icon="event"
                clearable
                @click:prepend-inner="openMenu($event)"
                @blur="validateDate($event,item)"
                :mask="item.mask"
              >
                <template slot="label">{{item.text}}</template>
              </v-text-field>
              <v-date-picker
                @input="item.valor = formatDate($event), item.index = false"
                locale="pt-br"
                v-model="item.data"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <!-- <v-flex :class="displayFlex" v-if="!create">
            <v-autocomplete
              v-model="estado"
              item-text="nome"
              :items="arrayEstados"
              label="Estado:"
              persistent-hint
              color="teal"
              prepend-icon="place"
              no-data-text="Consulta de Estado indisponível"
              return-object
            ></v-autocomplete>
          </v-flex>
          <v-flex :class="displayFlex" v-if="!create">
            <v-autocomplete
              v-model="cidade"
              item-text="nome"
              :items="arrayCidades"
              label="Cidade:"
              color="teal"
              persistent-hint
              prepend-icon="place"
              
              no-data-text="Selecione um Estado"
            ></v-autocomplete>
          </v-flex> -->
        </v-layout>
        <v-layout row wrap v-if="create && formEmp">
          <v-flex class="xs12 sm12 md12">
            <v-combobox
              :filter="filter"
              v-model="select"
              :items="itemsEmp"
              chips
              class="input-required"
              label="Vincular a empresa: "
              item-text="empresa.razao"
              :multiple="true"
              prepend-icon="domain"
              color="teal"
              item-value="_id"
              :rules="passRules"
              
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  close
                  class="v-chip--select-multi"
                  @input="remove(data.item)"
                >
                  <v-avatar
                    class="teal white--text"
                  >{{ data.item.empresa != undefined ? data.item.empresa.razao.slice(0, 1).toUpperCase() : ''}}</v-avatar>
                  {{ data.item.empresa != undefined ? data.item.empresa.razao : ''}}
                </v-chip>
              </template>
            </v-combobox>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import FormUsuario from "@/domain/conta/usuario/FormUsuario.js";
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
import EmpresaService from "@/domain/conta/empresa/EmpresaService.js";

export default {
  props: [
    "displayFlex",
    "create",
    "edit",
    "getDadosForm",
    "resetForm",
    "empEdit",
    "conta",
    "formEmp"
  ],
  components: {},
  data() {
    return {
      nomeRules: [
        v => !!v || "Campo obrigatório",
        v => /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]{3,90}$/.test(v) || "Digite um nome válido"
      ],
      emailRules: [
        v => !!v || "Campo obrigatório",
        v =>
          /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(
            v
          ) || "Digite um e-mail válido"
      ],
      passRules: [
        v => {
          if (v.length == 0) {
            return "Campo obrigatório";
          } else {
            return true;
          }
        }
      ],
      formUsuario: new FormUsuario(),
      valid: true,
      menu0: false,
      show1: false,
      show2: false,
      show3: false,
      arrayEstados: [],
      select: [],
      arrayCidades: [],
      estado: "",
      cidade: "",
      itemsEmp: [],
      logConsulta: "",
      route: this.$router.history.current.path
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getEstados;
      this.service = new UsuarioService(this.$http);
      if (this.edit && this.conta.id_usuario != undefined) {
        this.service.getUsuarioId(this.conta.id_usuario).then(success => {
          this.formUsuario.form.items.forEach(item => {
            if (
              success != undefined &&
              success.body[item.item_id] != undefined
            ) {
              item.valor = success.body[item.item_id];
            }
          });
        });
      }

      if (this.formEmp) {
        this.getEmpresas();
      }
    });
  },
  updated: function() {},
  watch: {
    resetForm: function(newV, oldV) {
      if (this.resetForm) {
        this.$refs.form.reset();
        this.$emit("changResetForm", false);
      }
    },
    estado: function() {
      this.getCidades();
    },
    getDadosForm: function(newV, oldV) {
      if (this.$refs.form.validate() && this.getDadosForm) {
        let dadosForm = {};
        this.emitDadosForm();
      } else if (!this.$refs.form.validate()) {
        this.$emit("emitDadosForm", false);
      }
    }
  },
  computed: {
    empresasMenu() {
      return this.$store.getters.empresasMenu;
    }
  },
  methods: {
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    },
    remove(item) {
      const index = this.select.indexOf(item);
      if (index >= 0) this.select.splice(index, 1);
    },
    getEmpresas() {
      // this.service = new EmpresaService(this.$http);
      // this.service.getEmpresasConta(this.conta.conta).then(body => {
        const body = this.empresasMenu;
        this.itemsEmp = body.empresas ? body.empresas.concat(body.emprs_not_admin) : [];
      // });
    },
    emitDadosForm() {
      
      let dados = {};
      this.formUsuario.form.items.forEach(item => {
        dados[item.item_id] = item.valor;
      });
      dados["estado"] = this.estado;
      dados["cidade"] = this.cidade;

      if (this.create) {
        let obj = {};
        dados["password"] = "teste";
        obj["dados"] = dados;
        obj["tipo"] = { component: "usuario" };
        if (this.formEmp) {
          let arrayIdEmp = [];
          this.select.forEach(item => arrayIdEmp.push(item.empresa._id));
          obj["empresas"] = arrayIdEmp;
        }
        obj.tipo["acao"] = this.edit == true ? "edit" : "create";
        this.$emit("emitDadosForm", obj);
      } else {
        this.$emit("emitDadosForm", dados);
      }
    },
    validateDate(field, item) {
      if (field.target.value.length == 10) {
        item.valor = field.target.value.split("-").join("");
        item.data = field.target.value
          .split("-")
          .reverse()
          .join("-");
      }
    },
    formatDate(date, menu) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}-${month}-${year}`;
    },
  },
  beforeMount: function() {
    this.$nextTick(function() {});
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
</style> 



// WEBPACK FOOTER //
// src/components/conta/usuario/formUsuario/FormUsuario.vue